/** Official Education names/categories, filled when the bundled visual pack is read. */
export interface GameItemInfo { name?: string; category?: string; group?: string }
const items = new Map<string,GameItemInfo>();
export function registerGameItem(id:string,info:GameItemInfo) { const key=id.replace(/^minecraft:/,'');items.set(key,{...items.get(key),...Object.fromEntries(Object.entries(info).filter(([,value])=>value!==undefined))}); }
export function gameItemInfo(id:string):GameItemInfo|undefined {
  if(id.includes(':')&&!id.startsWith('minecraft:'))return undefined;
  return items.get(id.replace(/^minecraft:/,''));
}
